import { FormInput } from '@/shared/form/form-element/form-input/form-input.ts';

export class CitySelect {
	private element: HTMLElement;
	private searchElement: HTMLInputElement;
	private searchInput: FormInput;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.searchElement = this.element.querySelector('.city-select__input .form-input');

		this.init();
	}

	public init = (): void => {
		window.app.classInstance.set(this, this.element);
		this.searchInput = new FormInput(this.searchElement);
	};
}
